import React, { useEffect, useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FieldHeader, TextInput } from "../../../../components/General";
import {
  LoginContainer,
  LoginButton,
  LoginGradient,
  LoginHeader,
  LoginLogo,
  LoginNav,
  LoginSubHeader,
  InnerNavContainer,
} from "../../components";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import loginIcon from "../../../../assets/logos/login.svg";
import useLogin from "../../../../hooks/mutations/useLogin";
import { ADMIN_INVITE_EMAIL_URL_PARAM } from "../Login/Login";
import { adminOnboardingFullPath } from "../../../../routes/paths";

const LoginAdminInvite = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has(ADMIN_INVITE_EMAIL_URL_PARAM)) {
      setEmail(searchParams.get(ADMIN_INVITE_EMAIL_URL_PARAM) || "");
    }
  }, [searchParams]);

  // Mutations
  const { mutate: loginFn } = useLogin({
    onSuccessHandler: () => navigate(adminOnboardingFullPath),
  });

  const handleLogin = async () => {
    if (!email || !password || !newPassword) {
      toast.error("Please fill out all fields");
      return;
    }

    loginFn({ email, password, new_password: newPassword });
  };

  return (
    <LoginContainer>
      <LoginNav>
        <InnerNavContainer>
          <LoginHeader>Hi, you're almost there!</LoginHeader>
          <LoginSubHeader>
            Enter the information provided in the invitation email.
          </LoginSubHeader>
          <FieldHeader sx={{ margin: "40px 0 0" }}>Email</FieldHeader>
          <TextInput
            id="email-field"
            size="small"
            placeholder="Work Email"
            value={email}
            focused
            onChange={(event) => setEmail(event.target.value)}
          />
          <FieldHeader>Temporary Password</FieldHeader>
          <TextInput
            id="password-field"
            placeholder="Password"
            size="small"
            type={showPassword ? "text" : "password"}
            focused
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    size={"small"}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOff fontSize="small" />
                    ) : (
                      <Visibility fontSize="small" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FieldHeader>New Password</FieldHeader>
          <TextInput
            id="new-password-field"
            placeholder="New Password"
            size="small"
            type={showNewPassword ? "text" : "password"}
            focused
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    size={"small"}
                    edge="end"
                  >
                    {showNewPassword ? (
                      <VisibilityOff fontSize="small" />
                    ) : (
                      <Visibility fontSize="small" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <LoginButton children={"Login"} onClick={handleLogin}></LoginButton>
        </InnerNavContainer>
      </LoginNav>
      <LoginGradient>
        <LoginLogo src={loginIcon} alt="logo" />
      </LoginGradient>
    </LoginContainer>
  );
};

export default LoginAdminInvite;
